/* eslint-disable indent */
/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 *
 * Vendors
 *
 */

import React, { memo, useState, useEffect, useContext, useRef } from 'react';
import { useSearchParams, useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import moment from 'moment';
import {
  Button,
  Popup,
  EllipsisPopup,
  Toggle,
  ConfirmModal,
  UploadFileModal,
  AlertModal,
  Conditional,
  Alert,
  Text,
  Grid,
  Row,
  Column,
  Space,
} from '@cashfree-intl/coherent';

import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import {
  roundOffNumber,
  copyToClipboard,
  titleCase,
  validateFileType,
  exportToCSV,
  getItemFromLocalStorage,
} from 'utils/common';
import {
  TX_STATUS_CLASSNAME,
  DEFAULT_CURRENT_PAGE,
  COUNTRY_CODE_OPTIONS,
  DEFAULT_LIMIT_OPTIONS,
  DATE_AND_TIME_FORMAT,
  ONE_MB_VALUE,
  EASY_SPLIT_SIGNATURES as signatures,
  SETTLE_NOW,
  PLACEHOLDER_TEXT,
  CURRENCY_SYMBOL,
  PROD,
  MINIMUM_SETTELEMENT_AMOUNT,
  VENDOR_ONBOARDING_V2_BLACKLIST,
} from 'utils/constants';

import PaginatedTable from 'components/PaginatedTable';
import { formatColumns } from 'components/PaginatedTable/helpers';

import { DELETED } from '../EasySplitDetails/constants';
import EVENTS from '../../constants/analytics';
import Analytics from '../../utils/analytics';

import {
  VENDOR_STATUS,
  HEADINGS,
  MENU_ITEMS,
  ADD_VENDOR,
  EDIT_VENDOR,
  DELETE_VENDOR,
  UPLOAD_BATCH_FILE_CHECKLIST,
  BATCH_UPLOAD_MODAL_TITLE_MAPPER,
  SETTLE_NOW_STATUS_MAPPER,
  IN_KYC_REVIEW,
  IN_REVIEW,
  IN_BENE_CREATION,
  MINIMUM_VENDOR_BALANCE,
  VENDOR_STATUS_MAPPING,
  VENDOR_STATUS_COLOR_MAPPING,
  VENDOR_STATUS_INFO_MAPPING,
  VENDOR_STATUS_INFO_HEADING_MAPPING,
  SHOW_COMPLETE_ACTIVATION_CTA,
  HEADINGS_INCREMENTAL_ONBOARDING,
  ACTION_REQUIRED,
  BENE_CREATION_FAILED,
  SUBMIT_KYC_FOR_REVIEW,
  KYC_PENDING,
} from './constants';
import makeSelectVendors from './selectors';
import reducer from './reducer';
import saga from './saga';

import {
  enableLoaderAction,
  updateTableDataAction,
  searchEasySplitVendorsAction,
  updateFilters as updateFiltersAction,
  resetFiltersAction,
  batchUploadSubmitAction,
  resetBatchUploadResponse,
  batchDownloadAction,
  getSettlementConfigAction,
  updateVendorNewAction,
  createVendorNewAction,
  vendorDataByIdAction,
  getVendorOdBalanceAction,
  initiateVendorOdAction,
  resetVendorDataByIdAction,
  resetPageAction,
  resetDataAction,
  createKycAction,
  downloadDocAction,
  getKycDocsAction,
  getBusinessInfoAction,
  createVendorAction,
  updateVendorAction,
  getDocsByUserAction,
  uploadVendorDocsAction,
  verifyPanAction,
  verifyGstAction,
  verifyCinAction,
  createOnboardingUsersAction,
} from './actions';

import { resetTwoFactorAuthentication as resetTwoFactorAuthenticationValue } from '../Toast/actions';
import { twoFactorAuthenticationSelector } from '../Toast/selectors';

import CustomIcon from '../../components/CustomIcons';

// import EasySplitModal from '../../components/EasySplitModal';
import EasySplitModalV2 from './components/EasySplitModalV2';
import DashboardFilters from '../DashboardFilters';
import EasySplitSettleNow from './components/EasySplitSettleNow';
import { MerchantContext } from '../../contexts/MerchantContext';
import { EASY_SPLIT_KNOW_MORE_LINK } from '../EasySplit/constants';
import { StyledAlertText, StyledCompleteActivationButton } from './styled';

export function Vendors({
  vendors,
  searchEasySplitVendors,
  updateFilters,
  resetFilters,
  updateTableData,
  enableLoader,
  submitBatchUpload,
  twoFactorAuthentication,
  resetBatchUploadResponseAction,
  resetTwoFactorAuthentication,
  getSettlementConfig,
  updateVendorNewData,
  createVendorNewData,
  vendorDataById,
  resetPage,
  menuSelected,
  resetData,
  getVendorOdBalance,
  initiateVendorOd,
  createKycData,
  downloadDoc,
  getKycDocs,
  getBusinessInfo,
  getDocsByUser,
  uploadVendorDocs,
  verifyPan,
  verifyCin,
  verifyGst,
  createOnboardingUser,
}) {
  useInjectReducer({ key: 'vendors', reducer });
  useInjectSaga({ key: 'vendors', saga });

  const [searchParams] = useSearchParams();

  const [openModalName, resetModalDisplay] = useState('');
  const [modalData, resetModalData] = useState({});
  const [editModalLoading, resetEditModalLoading] = useState(false);
  const [modalErr, resetModalErr] = useState('');
  const [selectedFile, resetSelectedFile] = useState(null);
  const [kycPayload, setKycPayload] = useState({});
  const [vendorId, setVendorId] = useState();
  const [businessInfo, setBusinessInfo] = useState({});
  const [vendorStatus, setVendorStatus] = useState();
  const [initialStep, setInitialStep] = useState();
  const [userInfo, setUserInfo] = useState({});
  const [vendorOnboardingDetails, setVendorOnboardingDetails] = useState({});
  // const [easySplitStatus, resetEasySplitStatus] = useState(
  //   EASY_SPLIT_STATUS.NOT_ACTIVE,
  // );

  const location = useLocation();
  const navigate = useNavigate();

  const rowClicked = useRef(false);

  const { pathname, hash } = location;

  const { ...merchantContextData } = useContext(MerchantContext);

  const { criticalMerchant, featureToggles = {} } = merchantContextData;

  const incrementalVendorOnboarding =
    VENDOR_ONBOARDING_V2_BLACKLIST in featureToggles &&
    !featureToggles[VENDOR_ONBOARDING_V2_BLACKLIST];

  const {
    isLoading,
    activeNavigation,
    tabs,
    batchUploadResponse,
    vendorIdData,
    vendorOdEnabled,
  } = vendors;

  const {
    filters,
    filtersForDisplay,
    hasPrev,
    hasNext,
    currentPageRowData,
    buttonContent,
    buttonCTAModal,
    data,
    vendorDocs = [],
  } = tabs[activeNavigation];

  const {
    isFileUploadSuccessful,
    failedCreateBatchVendors: uploadErrors = [],
  } = batchUploadResponse;

  const getTableData = (f = filters, currNav = activeNavigation) => {
    // make api call
    enableLoader();
    const { appliedFilters, pageNo, pageSize } = f;

    const formattedFilterObj = {
      ...appliedFilters,
      pageNo: pageNo - 1,
      pageSize,
    };

    if (
      appliedFilters.search &&
      appliedFilters.search.type &&
      appliedFilters.search.value
    ) {
      const {
        search: { type, value },
      } = appliedFilters;
      formattedFilterObj[type] = value;
      delete formattedFilterObj.search;
    }

    searchEasySplitVendors({
      activeNavigation: currNav,
      options: formattedFilterObj,
    });
  };

  const closeModal = () => {
    if (
      openModalName === 'BATCH' &&
      Object.keys(batchUploadResponse).length > 0
    ) {
      if (isFileUploadSuccessful) getTableData();
      resetBatchUploadResponseAction();
    }
    resetModalDisplay('');
    resetModalErr('');
    resetSelectedFile(null);
    setInitialStep();
    setUserInfo({});
    resetEditModalLoading(false);
    setVendorStatus();
  };

  // eslint-disable-next-line no-unused-vars
  const handleEasySplitVendorClick = ({ modalName, rowData }) => e => {
    // if (e) e.stopPropagation();
    resetModalData(rowData);
    resetModalDisplay(modalName);
  };

  const handleUpdateVendorData = payload => e => {
    e.stopPropagation();
    updateVendor(payload);
    Analytics.track(EVENTS.EASY_SPLIT.TOGGLE, {
      status: payload.rowData.status,
    });
    Analytics.trackEventWithNewNomenclature({
      eventName: 'Table_Row_Toggle',
      eventProperties: {
        row_id: payload.vendorId,
      },
    });
  };

  const updateVendor = ({ rowData, cb, errorCb }) => {
    enableLoader();
    const payload = {
      data: { ...rowData, updatedBy: getItemFromLocalStorage('merchantId') },
      cb,
      errorCb,
      statusChange: true,
    };
    updateVendorNewData(payload);
  };

  const getVendorDataForId = (rowData, completeActivationCTA = false) => {
    resetModalDisplay(EDIT_VENDOR);
    resetEditModalLoading(true);
    vendorDataById({
      vendorId: rowData.merchantVendorId,
      cb: response => {
        if (completeActivationCTA) {
          const {
            accountType,
            businessType,
            merchantVendorId,
            name,
          } = response;
          setUserInfo({
            userAccountType: accountType,
            userBusinessType: businessType,
            userName: merchantVendorId,
            name,
          });
          getDocsByUser({
            userName: merchantVendorId,
            userAccountType: accountType,
            userBusinessType: businessType,
          });
          switch (rowData?.status) {
            case ACTION_REQUIRED:
              setInitialStep(3);
              break;
            case BENE_CREATION_FAILED:
              setInitialStep(2);
              break;
            case IN_KYC_REVIEW:
              setInitialStep(3);
              break;
            default:
              break;
          }
        }
      },
    });
  };

  const getMenuItems = () =>
    MENU_ITEMS.map(obj => ({
      ...obj,
      image: () => <CustomIcon componentName={obj.key} fill="var(--PRIMARY)" />,
    }));

  const isEditMode = openModalName === EDIT_VENDOR;

  const onItemClick = rowData => (e, itemSelected) => {
    e.stopPropagation();
    setVendorId(rowData.merchantVendorId);
    if (itemSelected === DELETE_VENDOR) {
      handleEasySplitVendorClick({
        modalName: DELETE_VENDOR,
        rowData: {
          ...rowData,
          status: rowData.status === VENDOR_STATUS.DELETED,
        },
      })();
    } else {
      getVendorDataForId(rowData);
      if (!incrementalVendorOnboarding) {
        getKycDocs({
          vendorId: rowData.merchantVendorId,
          cb: response => {
            setKycPayload(response);
          },
        });
        getBusinessInfo({
          updatedBy: getItemFromLocalStorage('merchantId'),
          vendorId: rowData.merchantVendorId,
          cb: response => {
            const { accountType, businessType } = response;
            setBusinessInfo({ accountType, businessType });
          },
        });
      }
      setVendorStatus(rowData.status);
    }
  };

  const handleSampleFileClick = () => {
    window.open(tabs.EASY_SPLIT_BATCH.linkContent.url);
  };

  const handleBatchUploadResponse = response => {
    let modalName = '';

    if (response.error) {
      modalName = 'UPLOAD_FAILED';
      openModal({
        modalName,
        rowData: {
          ...BATCH_UPLOAD_MODAL_TITLE_MAPPER[modalName],
          description: '',
          errorMessage: response.error.message,
        },
      })();
    } else {
      const {
        totalRecords,
        failedRecords,
        failedCreateBatchVendors = [],
      } = response;

      if (failedRecords === totalRecords) modalName = 'UPLOAD_FAILED';
      else if (failedRecords < 1) modalName = 'UPLOAD_SUCCESS';
      else modalName = 'UPLOAD_ERROR';

      const { type, title, description } = BATCH_UPLOAD_MODAL_TITLE_MAPPER[
        modalName
      ];

      openModal({
        modalName,
        rowData: {
          ...response,
          validRecords: Number(totalRecords) - Number(failedRecords),
          type,
          title,
          description,
          uploadErrors: failedCreateBatchVendors,
        },
      })();
    }
  };

  const showAlertModal = [
    'UPLOAD_SUCCESS',
    'UPLOAD_FAILED',
    'UPLOAD_ERROR',
    'UPLOAD_CANCELLED',
  ].includes(openModalName);

  const handleAlertModalClose = () => {
    const modalName = 'UPLOAD_CANCELLED';
    openModal({
      modalName,
      rowData: BATCH_UPLOAD_MODAL_TITLE_MAPPER[modalName],
    })();
  };

  const onClose =
    openModalName === 'UPLOAD_ERROR' ? handleAlertModalClose : closeModal;

  const openModal = ({ modalName, rowData }) => e => {
    resetModalData(rowData);
    resetModalDisplay(modalName);
    if (e) e.stopPropagation();
  };

  const handleDownloadErrorButton = (errors, file) => {
    const fileName = file ? file.name : 'error-csv';
    const uploadErrorsHeader = {
      vendorId: 'VendorId',
      error: 'Error',
    };
    const uploadErrorArray = [uploadErrorsHeader].concat(errors);
    exportToCSV(fileName, uploadErrorArray);
  };

  const handleFileUpload = payload =>
    new Promise(resolve => {
      const { file } = payload;
      if (FileReader) {
        validateFileType(file, { signatures })
          .then(() => {
            resetSelectedFile(file);
            submitBatchUpload({
              data: file,
              cb: handleDownloadErrorButton,
              resolve,
            });
          })
          .catch(() => {
            resetSelectedFile(null);
            resolve({
              error: {
                message:
                  'Error while uploading file. Please check the file type and format as per the sample file',
              },
            });
          });
      }
    });

  const handleSettleNowBtnCLick = ({
    merchantVendorId,
    nextSettlementDate,
  }) => e => {
    e.stopPropagation();
    resetModalData({ merchantVendorId, nextSettlementDate });
    resetModalDisplay(SETTLE_NOW);
    Analytics.trackEventWithNewNomenclature({
      eventName: 'Settle_Now',
      eventProperties: {
        row_id: merchantVendorId,
      },
    });
  };

  const handleCompleteActivationClick = rowData => e => {
    getVendorDataForId(rowData, true);
    setVendorId(rowData?.merchantVendorId);
    e.stopPropagation();
    resetModalDisplay(EDIT_VENDOR);
    Analytics.trackEventWithNewNomenclature({
      eventName: 'Complete_Activation',
      eventProperties: {
        row_id: rowData.vendorId,
      },
    });
  };

  useEffect(() => {
    if (!isLoading) {
      const totalCount = data.length;
      const pageData = JSON.parse(JSON.stringify(data));
      let formattedData = [];
      if (incrementalVendorOnboarding) {
        switch (activeNavigation.toUpperCase().trim()) {
          case 'EASY_SPLIT_ALL': {
            formattedData = pageData.map(rowData => ({
              ...rowData,
              id: rowData.vendorId,
              txTime: moment(rowData.addedOn).format('MMM DD YYYY'),
              merchantVendor: () => (
                <div className="flex copy-to-clipboard-wrapper">
                  <span className="table-content">
                    {rowData.merchantVendorId}{' '}
                  </span>
                  {rowData.merchantVendorId &&
                  rowData.merchantVendorId !== 'N/A' ? (
                    // eslint-disable-next-line
                    <CustomIcon
                      componentName="COPY_TO_CLIPBOARD"
                      handleClick={copyToClipboard(rowData.merchantVendorId)}
                    />
                  ) : (
                    ''
                  )}
                </div>
              ),
              balance: () => (
                <>
                  <Conditional
                    if={rowData.balance <= MINIMUM_SETTELEMENT_AMOUNT}
                  >
                    <Popup
                      content="Settlement will be initiated only if vendor net settlement amount is greater than Rs 1/-"
                      trigger={
                        <span
                          className={`${
                            +rowData.balance < 0 ? 'order-amount-zero' : ''
                          }`}
                        >
                          {CURRENCY_SYMBOL.INR}{' '}
                          {!rowData.balance
                            ? rowData.balance.toFixed(2)
                            : roundOffNumber(rowData.balance)}
                        </span>
                      }
                    />
                  </Conditional>
                  <Conditional
                    if={rowData.balance > MINIMUM_SETTELEMENT_AMOUNT}
                  >
                    <span
                      className={`${
                        +rowData.balance < 0 ? 'order-amount-zero' : ''
                      }`}
                    >
                      {CURRENCY_SYMBOL.INR}{' '}
                      {!rowData.balance
                        ? rowData.balance.toFixed(2)
                        : roundOffNumber(rowData.balance)}
                    </span>
                  </Conditional>
                </>
              ),
              nextSettlementDate:
                moment(rowData.nextSettlementDate).format(
                  DATE_AND_TIME_FORMAT,
                ) || PLACEHOLDER_TEXT,
              txStatus: () => (
                <div>
                  <Popup
                    content={
                      <Conditional
                        if={!!VENDOR_STATUS_INFO_MAPPING[rowData.status]}
                      >
                        <Space direction="column" gap={1}>
                          <Text strong variant="b12">
                            {VENDOR_STATUS_INFO_HEADING_MAPPING[
                              (rowData?.status)
                            ] || titleCase(rowData?.status || PLACEHOLDER_TEXT)}
                          </Text>
                          <Text variant="b12" color="bodyLight">
                            {VENDOR_STATUS_INFO_MAPPING[rowData.status]}
                          </Text>
                        </Space>
                      </Conditional>
                    }
                    trigger={
                      <span>
                        <Text
                          color={
                            VENDOR_STATUS_COLOR_MAPPING[(rowData?.status)] ||
                            'bodyLight'
                          }
                        >
                          {VENDOR_STATUS_MAPPING[(rowData?.status)] ||
                            titleCase(rowData?.status || PLACEHOLDER_TEXT)}
                        </Text>
                      </span>
                    }
                    position="left center"
                  />
                </div>
              ),
              completeActivationCTA: () =>
                rowData.status !== VENDOR_STATUS.DELETED && (
                  <Conditional
                    if={SHOW_COMPLETE_ACTIVATION_CTA.includes(rowData.status)}
                  >
                    <StyledCompleteActivationButton
                      secondary
                      size="small"
                      className="my-1"
                      onClick={handleCompleteActivationClick(rowData)}
                    >
                      Complete Activation
                    </StyledCompleteActivationButton>
                  </Conditional>
                ),
              editVendorCTA: () =>
                rowData.status !== VENDOR_STATUS.DELETED && (
                  <Space alignItems="center" justifyContent="flex-end" gap={3}>
                    <Space alignItems="center" className="fit-content">
                      <div className="mr-1 fit-content">
                        <Toggle
                          disabled={
                            !['ACTIVE', 'BLOCKED'].includes(rowData?.status)
                          }
                          active={rowData.status !== VENDOR_STATUS.BLOCKED}
                          onToggle={handleUpdateVendorData({
                            rowData: {
                              ...rowData,
                              status:
                                rowData.status === VENDOR_STATUS.ACTIVE
                                  ? VENDOR_STATUS.BLOCKED
                                  : VENDOR_STATUS.ACTIVE,
                              vendorStatus: VENDOR_STATUS.BLOCKED
                                ? IN_BENE_CREATION
                                : rowData.status,
                            },
                          })}
                        />
                      </div>
                      <Text
                        className="fit-content"
                        color={
                          rowData?.status === VENDOR_STATUS.ACTIVE
                            ? 'bodyLight'
                            : 'disabled'
                        }
                      >
                        {rowData?.status === VENDOR_STATUS.BLOCKED
                          ? 'Block'
                          : 'Active'}
                      </Text>
                    </Space>
                    <div className="">
                      <EllipsisPopup
                        menuItems={getMenuItems()}
                        onClick={onItemClick(rowData)}
                      />
                    </div>
                  </Space>
                ),
            }));
            break;
          }
          default:
            formattedData = [...data];
        }
      } else {
        switch (activeNavigation.toUpperCase().trim()) {
          case 'EASY_SPLIT_ALL': {
            formattedData = pageData.map(rowData => ({
              ...rowData,
              id: rowData.vendorId,
              txTime: moment(rowData.addedOn).format(DATE_AND_TIME_FORMAT),
              merchantVendor: () => (
                <div className="flex copy-to-clipboard-wrapper">
                  <span className="table-content">
                    {rowData.merchantVendorId}{' '}
                  </span>
                  {rowData.merchantVendorId &&
                  rowData.merchantVendorId !== 'N/A' ? (
                    // eslint-disable-next-line
                    <CustomIcon
                      componentName="COPY_TO_CLIPBOARD"
                      handleClick={copyToClipboard(rowData.merchantVendorId)}
                    />
                  ) : (
                    ''
                  )}
                </div>
              ),
              balance: () => (
                <>
                  <Conditional
                    if={rowData.balance <= MINIMUM_SETTELEMENT_AMOUNT}
                  >
                    <Popup
                      content="Settlement will be initiated only if vendor net settlement amount is greater than Rs 1/-"
                      trigger={
                        <span
                          className={`${
                            +rowData.balance < 0 ? 'order-amount-zero' : ''
                          }`}
                        >
                          {CURRENCY_SYMBOL.INR}{' '}
                          {!rowData.balance
                            ? rowData.balance.toFixed(2)
                            : roundOffNumber(rowData.balance)}
                        </span>
                      }
                    />
                  </Conditional>
                  <Conditional
                    if={rowData.balance > MINIMUM_SETTELEMENT_AMOUNT}
                  >
                    <span
                      className={`${
                        +rowData.balance < 0 ? 'order-amount-zero' : ''
                      }`}
                    >
                      {CURRENCY_SYMBOL.INR}{' '}
                      {!rowData.balance
                        ? rowData.balance.toFixed(2)
                        : roundOffNumber(rowData.balance)}
                    </span>
                  </Conditional>
                </>
              ),
              nextSettlementDate:
                moment(rowData.nextSettlementDate).format(
                  DATE_AND_TIME_FORMAT,
                ) || PLACEHOLDER_TEXT,
              settleNowBtn: () => {
                const lowBalance = +rowData.balance < MINIMUM_VENDOR_BALANCE;
                const enableSettleNow =
                  vendorOdEnabled &&
                  !lowBalance &&
                  rowData.status === VENDOR_STATUS.ACTIVE;

                return (
                  <>
                    {enableSettleNow ? (
                      <Button
                        secondary
                        size="small"
                        onClick={handleSettleNowBtnCLick(rowData)}
                      >
                        Settle Now
                      </Button>
                    ) : (
                      <>
                        <Conditional if={!lowBalance}>
                          <Button
                            primary
                            disabled
                            size="small"
                            onClick={handleSettleNowBtnCLick(rowData)}
                          >
                            Settle Now
                          </Button>
                        </Conditional>
                        <Conditional if={lowBalance}>
                          <Popup
                            content={`Low balance. You can trigger On-Demand Settlements only for an amount greater than ${
                              CURRENCY_SYMBOL.INR
                            } ${MINIMUM_VENDOR_BALANCE}`}
                            trigger={
                              <span className="pointer">
                                <Button primary disabled>
                                  SettleNow
                                </Button>
                              </span>
                            }
                            position="top center"
                          />
                        </Conditional>
                      </>
                    )}
                  </>
                );
              },
              txStatus: () => (
                <div>
                  <span
                    className={`w-600 ${TX_STATUS_CLASSNAME[rowData.status] ||
                      ''}`}
                  >
                    {rowData.status === IN_KYC_REVIEW
                      ? titleCase(IN_REVIEW)
                      : titleCase(rowData.status || PLACEHOLDER_TEXT)}
                  </span>
                  <Conditional if={rowData.status === 'BLOCKED'}>
                    <Popup
                      content="This vendor has been blocked. Unblock the vendor to process the settlement"
                      trigger={
                        <span className="pointer ml-1">
                          <CustomIcon componentName="INFO" />
                        </span>
                      }
                      position="top"
                    />
                  </Conditional>
                  <Conditional if={rowData.status === 'ON_HOLD'}>
                    <Popup
                      content="Documents are not approved. Either some of the documents are missing or the documents have been rejected. Please visit edit section to update documents"
                      trigger={
                        <span className="pointer ml-1">
                          <CustomIcon componentName="INFO" />
                        </span>
                      }
                      position="top"
                    />
                  </Conditional>
                  <Conditional if={rowData.status === 'BENE_CREATION_FAILED'}>
                    <Popup
                      content="Beneficiary creation failed, please update the bank details of the vendor to activate vendor"
                      trigger={
                        <span className="pointer ml-1">
                          <CustomIcon componentName="INFO" />
                        </span>
                      }
                      position="top"
                    />
                  </Conditional>
                </div>
              ),

              editVendorCTA: () =>
                rowData.status !== VENDOR_STATUS.DELETED && (
                  <Space alignItems="center" justifyContent="end" gap={3}>
                    <div className="">
                      <Popup
                        content="Change Status"
                        position="bottom right"
                        offset="10px"
                        trigger={
                          <Toggle
                            active={rowData.status === VENDOR_STATUS.ACTIVE}
                            onToggle={handleUpdateVendorData({
                              rowData: {
                                ...rowData,
                                status:
                                  rowData.status === VENDOR_STATUS.ACTIVE
                                    ? VENDOR_STATUS.BLOCKED
                                    : VENDOR_STATUS.ACTIVE,
                                vendorStatus: VENDOR_STATUS.BLOCKED
                                  ? IN_BENE_CREATION
                                  : rowData.status,
                              },
                            })}
                          />
                        }
                      />
                    </div>
                    <Conditional if={rowData.dashboardAccess}>
                      <Popup
                        content="Enabled"
                        trigger={
                          <span className="pointer">
                            <CustomIcon componentName="EYE" />
                          </span>
                        }
                        position="bottom"
                      />
                    </Conditional>
                    <Conditional if={!rowData.dashboardAccess}>
                      <Popup
                        content="Disabled"
                        trigger={
                          <span className="pointer">
                            <CustomIcon componentName="EYE_SLASH" />
                          </span>
                        }
                        position="bottom center"
                      />
                    </Conditional>
                    <EllipsisPopup
                      menuItems={getMenuItems()}
                      onClick={onItemClick(rowData)}
                    />
                  </Space>
                ),
            }));
            break;
          }
          default:
            formattedData = [...data];
        }
      }

      const hasPrevEnabled = filters.pageNo !== 1;
      const hasNextEnabled = totalCount >= filters.pageSize;

      updateTableData({
        totalCount,
        currentPageRowData: formattedData,
        hasPrevEnabled,
        hasNextEnabled,
      });
    }
  }, [isLoading, data]);

  useEffect(() => {
    getTableData(filters, activeNavigation);
    getSettlementConfig();
  }, [filters, activeNavigation, searchParams.get('env')]);

  useEffect(() => {
    if (twoFactorAuthentication) {
      getTableData();
      getSettlementConfig();
      resetTwoFactorAuthentication(false);
    }
    // for resetting the redux state
    return () => resetData();
  }, [twoFactorAuthentication]);

  const onPageChange = type => {
    const options = { ...filters, filtersForDisplay };
    switch (type) {
      case 'NEXT':
        options.pageNo += 1;
        break;
      case 'PREV':
        options.pageNo -= 1;
        break;
      default:
        break;
    }
    updateFilters(options);
  };

  const handleSampleFileDownload = e => {
    e.preventDefault();
    window.open(tabs.EASY_SPLIT_BATCH.linkContent.url, '_self');
    Analytics.track(EVENTS.EASY_SPLIT.DOWNLOAD_SAMPLE_FILE);
  };

  const onLimitChange = (e, limitChangeData) => {
    const options = {
      ...filters,
      pageNo: DEFAULT_CURRENT_PAGE,
      pageSize: parseInt(limitChangeData.value, 10),
      filtersForDisplay,
    };
    updateFilters(options);
    Analytics.track(EVENTS.EASY_SPLIT.PAGE_SIZE, {
      pageSize: limitChangeData.value,
    });
  };

  useEffect(() => {
    resetEditModalLoading(false);
    if (vendorIdData) {
      let phoneNumber = vendorIdData.phone;
      let numberInitial = '+91';
      if (phoneNumber && phoneNumber.length) {
        if (
          COUNTRY_CODE_OPTIONS.findIndex(
            obj => obj.text === phoneNumber.slice(0, 2),
          ) !== -1
        ) {
          numberInitial = phoneNumber.slice(0, 2);
          phoneNumber = phoneNumber.slice(2);
        } else if (
          COUNTRY_CODE_OPTIONS.findIndex(
            obj => obj.text === phoneNumber.slice(0, 3),
          ) !== -1
        ) {
          numberInitial = phoneNumber.slice(0, 3);
          if (phoneNumber.startsWith('+91-')) {
            phoneNumber = phoneNumber.slice(4);
          } else {
            phoneNumber = phoneNumber.slice(3);
          }
        } else if (phoneNumber.startsWith('0')) {
          phoneNumber = phoneNumber.slice(1);
        }
      }
      resetModalData({
        ...vendorIdData,
        phone: phoneNumber,
        numberInitial,
        scheduleOption:
          vendorIdData.schedule && vendorIdData.schedule.scheduleId.toString(),
        vendorId: vendorIdData.merchantVendorId,
      });
    }
  }, [vendorIdData]);

  const submitDeleteVendorModal = () => {
    updateVendor({
      rowData: {
        ...modalData,
        status: VENDOR_STATUS.DELETED,
        updatedBy: getItemFromLocalStorage('merchantId'),
      },
      cb: () => {},
      errorCb: () => {},
    });
    closeModal();
    Analytics.track(EVENTS.EASY_SPLIT.DELETE_VENDOR);
  };

  const renderConfirmModal = () => (
    <ConfirmModal
      danger
      title="Delete Vendor"
      onClose={closeModal}
      onConfirm={submitDeleteVendorModal}
      confirmText="Delete"
      confirmBtnEvent="Danger_Button_Delete_Vendor_Confirm"
      closeBtnEvent="Link_Button_Delete_Vendor_Cancel"
      closeCrossEvent="Delete_Vendor_Icon_Close"
    >
      Payments or settlements cannot be made to {modalData.merchantVendorId}{' '}
      after you delete. Are you sure you want to delete it?
    </ConfirmModal>
  );

  const headings = incrementalVendorOnboarding
    ? HEADINGS_INCREMENTAL_ONBOARDING[activeNavigation]
    : HEADINGS[activeNavigation];
  const settleNowStatusObj = SETTLE_NOW_STATUS_MAPPER[openModalName];

  const closeEasySplitSettleNow = () => {
    resetModalDisplay('');
    resetModalData({});
  };

  const redirectToSettings = () => {
    window.location.href = `${
      process.env.COMMON_BASE_PATH
    }/settings?env=${searchParams.get('env') || PROD}`;
  };

  let vendorDetailsPayload = {};
  const handleVendorDetailsPayload = (
    payload,
    showVendorDbToggle,
    incrementStep = () => {},
  ) => {
    vendorDetailsPayload = {
      ...vendorDetailsPayload,
      ...payload,
      showVendorDbToggle,
    };
    if (incrementalVendorOnboarding) {
      const updatedPayload = {
        data: {
          merchantVendorId: vendorId,
          updatedBy: getItemFromLocalStorage('merchantId'),
          vendorStatus,
          ...vendorOnboardingDetails,
        },
        cb: () => {
          incrementStep();
        },
        incrementalVendorOnboarding,
      };
      if (isEditMode) {
        updateVendorNewData(updatedPayload);
      } else {
        createVendorNewData(updatedPayload);
      }
    }
  };
  const submitKycModal = (
    fileObj,
    isCritical,
    isDocUploaded,
    actions,
    merchantVendorId,
  ) => {
    const updatedPayload = {
      data: fileObj,
      updatedBy: getItemFromLocalStorage('merchantId'),
      merchantVendorId,
      cb: () => {
        actions.setSubmitting(false);
        if (isEditMode) {
          resetModalDisplay('VENDOR_EDIT_SUCCESS');
        } else if (!isCritical && !isDocUploaded) {
          resetModalDisplay('VENDOR_ADDED_SUCCESS');
        } else if (isDocUploaded) {
          resetModalDisplay('DOC_ADDED_SUCCESS');
        } else if (!isDocUploaded && isCritical) {
          resetModalDisplay('DOC_NOT_ADDED_SUCCESS');
        }
      },
      errCb: () => {
        resetModalDisplay('VENDOR_ADDED_FAILED');
      },
      actions,
    };
    createKycData(updatedPayload);
  };
  const triggerVendorDataApi = (
    payload,
    actions,
    isCritical,
    isDocUploaded,
  ) => {
    let showVendorDbToggle;
    if ('dashboardAccess' in payload) {
      showVendorDbToggle = true;
    }
    const fileObj = payload.completeFileObj;
    // eslint-disable-next-line no-param-reassign
    delete payload.completeFileObj;
    const updatedPayload = {
      data: {
        ...payload,
        updatedBy: getItemFromLocalStorage('merchantId'),
        vendorStatus,
      },
      cb: () => {
        actions.setSubmitting(false);
        submitKycModal(
          fileObj,
          isCritical,
          isDocUploaded,
          actions,
          payload.vendorId,
        );
        closeModal();
      },
      errorCb: err => {
        resetModalErr(err);
      },
      actions,
      showVendorDbToggle,
      incrementalVendorOnboarding,
    };
    if (isEditMode) Analytics.track(EVENTS.EASY_SPLIT.EDIT_VENDOR);
    return isEditMode
      ? updateVendorNewData(updatedPayload)
      : createVendorNewData(updatedPayload);
  };
  const handleKycDataPayload = (
    payload,
    actions,
    isCritical,
    isDocUploaded,
  ) => {
    vendorDetailsPayload = {
      ...vendorDetailsPayload,
      ...payload,
    };
    triggerVendorDataApi(
      vendorDetailsPayload,
      actions,
      isCritical,
      isDocUploaded,
    );
  };

  const submitVendorDocuments = (payload, docNameTypeMapping) => {
    resetModalDisplay(SUBMIT_KYC_FOR_REVIEW);
    resetModalData({
      payload,
      docNameTypeMapping,
      updateVendorInfo: isEditMode,
    });
  };

  const submitKYCConfirmation = () => {
    const { payload, docNameTypeMapping } = modalData;

    const { userName, userAccountType, userBusinessType } = userInfo;
    uploadVendorDocs({
      userName,
      userAccountType,
      userBusinessType,
      payload,
      docNameTypeMapping,
      updatedBy: +getItemFromLocalStorage('merchantId'),
      cb: () => {
        closeModal();
      },
    });
  };

  const submitVendorDetails = (
    payload,
    actions,
    incrementStep,
    vendorCreated,
  ) => {
    const {
      vendorId: merchantVendorId,
      accountType: userAccountType,
      businessType: userBusinessType,
    } = payload;
    setUserInfo({
      userName: merchantVendorId,
      userAccountType,
      userBusinessType,
    });

    const updatedPayload = {
      data: {
        ...payload,
        updatedBy: getItemFromLocalStorage('merchantId'),
        vendorStatus,
      },
      actions,
      cb: response => {
        getDocsByUser({
          userName: merchantVendorId,
          userAccountType,
          userBusinessType,
          actions,
          cb: documents => {
            if (!documents || documents.length <= 0) {
              closeModal();
            } else {
              incrementStep();
            }
          },
        });
        setVendorStatus(response.status);
      },
      incrementalVendorOnboarding,
    };
    if (isEditMode || vendorCreated) {
      // call the update api if after creation, merchant comes back from Step 3 to Step 2
      if (!updatedPayload?.data?.merchantVendorId)
        updatedPayload.data.merchantVendorId = merchantVendorId;

      updateVendorNewData(updatedPayload);
    } else {
      createVendorNewData(updatedPayload);
    }
    const vendorFormData = {
      ...payload,
    };
    setVendorOnboardingDetails(vendorFormData);
  };

  const handleRowClick = rowData => {
    if (rowData.status === DELETED) return;
    const { env = '' } = Object.fromEntries(searchParams);
    rowClicked.current = true;
    // taking user to the EasySplit details component
    navigate(
      `${pathname}/easy-split-details?activeNavigation=${'VENDORS'}&merchantVendorId=${
        rowData.merchantVendorId
      }&isCritical=${criticalMerchant || false}&vendorOd=${vendorOdEnabled}${
        env ? `&env=${env}` : ''
      }${hash}`,
      {
        rowId: rowData.id,
      },
    );
  };

  const saveAndExitKycForm = (payload, docNameTypeMapping) => {
    if (Object.keys(userInfo).length) {
      const { userName, userAccountType, userBusinessType } = userInfo;
      uploadVendorDocs({
        userName,
        userAccountType,
        userBusinessType,
        payload,
        docNameTypeMapping,
        updatedBy: +getItemFromLocalStorage('merchantId'),
        cb: () => {
          resetModalDisplay(KYC_PENDING);
        },
      });
    }
  };

  const combinedColumn = [
    {
      accessorKey: 'nextSettlementDate',
      header: 'Next Settlement Cycle',
      ellipsis: true,
      cell: ({ nextSettlementDate }) => nextSettlementDate,
    },
    {
      accessorKey: 'settleNowBtn',
      header: ' ',
      ellipsis: true,
      cell: ({ settleNowBtn }) =>
        typeof settleNowBtn === 'function' ? settleNowBtn() : settleNowBtn,
    },
    {
      accessorKey: 'txStatus',
      header: 'Status',
      ellipsis: true,
      width: 200,
      cell: ({ txStatus }) => (
        <Space alignItems="center" gap={4}>
          {txStatus()}
        </Space>
      ),
    },
    {
      accessorKey: 'editVendorCTA',
      header: ' ',
      ellipsis: true,
      width: 300,
      cell: ({ editVendorCTA }) => editVendorCTA(),
    },
  ];

  let FORMATTED_COLUMN_ID = formatColumns(headings);
  FORMATTED_COLUMN_ID = [
    ...FORMATTED_COLUMN_ID.slice(0, -4),
    ...combinedColumn,
  ];

  const noRecordsObj = {
    icon: <CustomIcon componentName="BOX" />,
    text: 'No Vendor Found',
    description: 'Click Add New Vendor to add your first Vendor.',
  };

  return (
    <div className="vendors">
      <StyledAlertText>
        <Text className="text-light mt-0">
          All vendors are shown here.{' '}
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            href={EASY_SPLIT_KNOW_MORE_LINK}
            target="_blank"
            data-event-name="Link_KnowMore"
          >
            Know more
          </a>
        </Text>
      </StyledAlertText>
      <StyledAlertText>
        <Alert size="md" type="warning" compact bordered>
          Easy Split configuration is now available in Settings
          <Button
            className="ml-3"
            primary
            onClick={redirectToSettings}
            data-event-name="Primary_Button_Explore"
          >
            Explore
          </Button>
        </Alert>
      </StyledAlertText>
      <div className="filters-wrapper">
        <DashboardFilters
          menuSelected={menuSelected}
          filters={filters}
          filtersForDisplay={filtersForDisplay}
          activeNavigation={activeNavigation}
          getTableDataFn={getTableData}
          resetFilterFn={resetFilters}
          updateFilterFn={updateFilters}
          resetPageFn={resetPage}
          incrementalVendorOnboarding={incrementalVendorOnboarding}
        />
        <div className="vendors-tab-cta-wrapper">
          <div className="sample-file-download-link">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              onClick={handleSampleFileDownload}
              data-event-name={`Link_${tabs.EASY_SPLIT_BATCH.linkContent.text}`}
            >
              {tabs.EASY_SPLIT_BATCH.linkContent.text}
            </a>
          </div>
          <Button
            primary
            onClick={handleEasySplitVendorClick({
              modalName: tabs.EASY_SPLIT_BATCH.buttonCTAModal,
              rowData: {},
            })}
            data-event-name={`Primary_Button_${
              tabs.EASY_SPLIT_BATCH.buttonContent
            }`}
          >
            {tabs.EASY_SPLIT_BATCH.buttonContent}
          </Button>
          <Button
            primary
            onClick={handleEasySplitVendorClick({
              modalName: buttonCTAModal,
              rowData: {},
            })}
            data-event-name={`Primary_Button_${buttonContent}`}
          >
            {buttonContent}
          </Button>
        </div>
      </div>
      {activeNavigation && (
        <PaginatedTable
          data={currentPageRowData}
          emptyTableComponent={noRecordsObj}
          tableHeading={FORMATTED_COLUMN_ID}
          limit={filters.pageSize}
          limitOptions={DEFAULT_LIMIT_OPTIONS}
          hasPrev={hasPrev}
          hasNext={hasNext}
          currentPage={filters.pageNo}
          currentPageCount={currentPageRowData.length}
          onPageChange={onPageChange}
          onLimitChange={onLimitChange}
          onRowClick={handleRowClick}
          fetching={isLoading}
        />
      )}
      <Conditional if={openModalName === SETTLE_NOW}>
        <EasySplitSettleNow
          open
          closeModal={closeEasySplitSettleNow}
          data={modalData}
          resetModalData={resetModalData}
          resetModalDisplay={resetModalDisplay}
          getVendorOdBalance={getVendorOdBalance}
          initiateVendorOd={initiateVendorOd}
        />
      </Conditional>
      <Conditional if={openModalName === 'VENDOR_ADDED_SUCCESS'}>
        <AlertModal
          type="success"
          title="Vendor Added Successfully"
          onClose={closeModal}
          eventNameOnClose="Vendor_Added_Successfully_Close"
        />
      </Conditional>
      <Conditional if={openModalName === 'DOC_ADDED_SUCCESS'}>
        <AlertModal
          type="success"
          title="Vendor Details Submitted Successfully"
          onClose={closeModal}
          eventNameOnClose="Vendor_Details_Submitted_Successfully_Close"
        >
          <p>
            The vendor details are currently under review. During this review
            period, vendors cannot perform any transactions. You can check the
            vendor status from the dashboard under the Account Status section.
          </p>
        </AlertModal>
      </Conditional>
      <Conditional if={openModalName === 'DOC_NOT_ADDED_SUCCESS'}>
        <AlertModal
          type="success"
          title="Vendor Details Submitted Successfully"
          onClose={closeModal}
          eventNameOnClose="Vendor_Details_Submitted_Successfully_Close"
        >
          <p>
            The vendor details are currently under review. Upload the required
            documents using the Edit section in the dashboard. During this
            review period, vendors cannot perform any transactions. You can
            check the vendor status from the dashboard under the Account Status
            section.
          </p>
        </AlertModal>
      </Conditional>
      <Conditional if={openModalName === 'VENDOR_EDIT_SUCCESS'}>
        <AlertModal
          type="success"
          title="Vendor Details Updated Successfully"
          onClose={closeModal}
          eventNameOnClose="Vendor_Details_Updated_Successfully_Close"
        >
          <p>
            During the review period, transactions are allowed but settlement
            will be on hold till the status is active
          </p>
        </AlertModal>
      </Conditional>
      <Conditional if={openModalName === 'VENDOR_ADDED_FAILED'}>
        <AlertModal
          type="danger"
          title="Vendor Details Not Added"
          onClose={closeModal}
          eventNameOnClose="Vendor_Details_Not_Added_Close"
        >
          <p>
            There was a problem saving the details. Please add the vendor
            details and try again.
          </p>
        </AlertModal>
      </Conditional>
      <Conditional if={openModalName === KYC_PENDING}>
        <AlertModal
          type="success"
          title="KYC Pending"
          onClose={closeModal}
          eventNameOnClose="Primary_Button_Save_&_Exit_Close"
        >
          <p>
            Your progress is saved. To finish your pending KYC, click
            &quot;Complete Activation&apos; on the dashboard.
          </p>
        </AlertModal>
      </Conditional>
      <Conditional if={openModalName === SUBMIT_KYC_FOR_REVIEW}>
        <ConfirmModal
          success
          title="Submit KYC"
          onClose={closeModal}
          onConfirm={submitKYCConfirmation}
          confirmText="Confirm"
          confirmBtnEvent="Primary_Button_Submit_KYC_Confirm"
          closeBtnEvent="Link_Button_Submit_KYC_Cancel"
          closeCrossEvent="Submit_KYC_Icon_Close"
        >
          Once submitted, documents can&apos;t be edited. Our team will review
          and contact you if needed. Are you sure you want to submit?
        </ConfirmModal>
      </Conditional>
      {openModalName && (
        <>
          <EasySplitModalV2
            open={[ADD_VENDOR, EDIT_VENDOR].includes(openModalName)}
            isEditMode={isEditMode}
            closeModal={closeModal}
            data={isEditMode ? { ...modalData } : {}}
            modalErr={modalErr}
            scheduleOptions={vendors.schedules}
            editModalLoading={editModalLoading}
            handleVendorDetailsPayload={handleVendorDetailsPayload}
            handleKycDataPayload={handleKycDataPayload}
            downloadDoc={downloadDoc}
            vendorId={vendorId}
            kycData={isEditMode ? kycPayload : {}}
            businessRelatedInfo={isEditMode ? businessInfo : {}}
            isMerchantCritical={criticalMerchant}
            vendorStatus={vendorStatus}
            vendorDocs={vendorDocs}
            submitVendorDocuments={submitVendorDocuments}
            initialStep={initialStep}
            verifyCin={verifyCin}
            verifyGst={verifyGst}
            verifyPan={verifyPan}
            incrementalVendorOnboarding={incrementalVendorOnboarding}
            createOnboardingUser={createOnboardingUser}
            submitVendorDetails={submitVendorDetails}
            saveAndExitKycForm={saveAndExitKycForm}
            userInfo={userInfo}
            vendorOnboardingDetails={vendorOnboardingDetails}
          />
        </>
      )}
      {openModalName === DELETE_VENDOR &&
        modalData &&
        modalData.merchantVendorId &&
        renderConfirmModal()}
      {openModalName === 'BATCH' && (
        <UploadFileModal
          sizeLimit={ONE_MB_VALUE * 8} // 10 MB
          checkList={UPLOAD_BATCH_FILE_CHECKLIST}
          modalTitle="Upload Batch Vendor File"
          onResponse={handleBatchUploadResponse}
          onFileUpload={handleFileUpload}
          onClose={closeModal}
          onSampleFileClick={handleSampleFileClick}
        />
      )}
      {showAlertModal && (
        <AlertModal
          type={modalData.type || 'warning'}
          title={modalData.title || ''}
          onClose={onClose}
        >
          {modalData.errorMessage && (
            <div className="alert-modal-error-message">
              {modalData.errorMessage}
            </div>
          )}
          {modalData.description && (
            <div className="alert-modal-description">
              {modalData.description}
            </div>
          )}
          <div className="alert-modal-content mt-2">
            {!!modalData.totalRecords && (
              <div>
                {[
                  { key: 'totalRecords', text: 'Total records' },
                  { key: 'validRecords', text: 'Valid records' },
                  { key: 'failedRecords', text: 'Invalid records' },
                ].map(obj => (
                  <div
                    className="stats-details-wrapper vendors-stat-details"
                    key={obj.key}
                  >
                    <div className="stats-label">{obj.text}</div>
                    <div className="stats-value">{modalData[obj.key]}</div>
                  </div>
                ))}
              </div>
            )}
            {modalData.uploadErrors && modalData.uploadErrors.length && (
              <div className="error-log-download-cta vendors-download-cta">
                <Button
                  size="small"
                  secondary
                  onClick={() =>
                    handleDownloadErrorButton(uploadErrors, selectedFile)
                  }
                  data-event-name="Form_Vendor_Button_DownloadErrorLog"
                >
                  Download Error Log
                </Button>
              </div>
            )}
          </div>
        </AlertModal>
      )}
      {!!settleNowStatusObj && (
        <AlertModal
          type={settleNowStatusObj.type}
          title={settleNowStatusObj.title}
          onClose={() => {
            closeModal();
            getTableData();
          }}
          eventNameOnClose={
            settleNowStatusObj.title
              ? `${settleNowStatusObj.title.split(' ').join('_')}_Close`
              : ''
          }
        >
          <p className="text-light">{settleNowStatusObj.description}</p>
          <Grid
            className={`alert-modal content-wrapper ${settleNowStatusObj.type}`}
          >
            {Object.keys(settleNowStatusObj.content).map(key => (
              <Row columns={2} key={key}>
                <Column>
                  <span className="text-light">
                    {settleNowStatusObj.content[key]}
                  </span>
                </Column>
                <Column>
                  <span className="text-dark w-600">{modalData[key]}</span>
                </Column>
              </Row>
            ))}
          </Grid>
        </AlertModal>
      )}
    </div>
  );
}

Vendors.propTypes = {
  vendors: PropTypes.object.isRequired,
  twoFactorAuthentication: PropTypes.any.isRequired,
  searchEasySplitVendors: PropTypes.func.isRequired,
  updateTableData: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  resetFilters: PropTypes.func.isRequired,
  enableLoader: PropTypes.func.isRequired,
  submitBatchUpload: PropTypes.func,
  createVendorNewData: PropTypes.func,
  vendorDataById: PropTypes.func.isRequired,
  resetBatchUploadResponseAction: PropTypes.func.isRequired,
  resetTwoFactorAuthentication: PropTypes.func.isRequired,
  getSettlementConfig: PropTypes.func.isRequired,
  updateVendorNewData: PropTypes.func.isRequired,
  resetPage: PropTypes.func.isRequired,
  menuSelected: PropTypes.any.isRequired,
  resetData: PropTypes.func.isRequired,
  getVendorOdBalance: PropTypes.func.isRequired,
  initiateVendorOd: PropTypes.func.isRequired,
  createKycData: PropTypes.func,
  downloadDoc: PropTypes.func,
  getKycDocs: PropTypes.func,
  getBusinessInfo: PropTypes.func,
  getDocsByUser: PropTypes.func,
  uploadVendorDocs: PropTypes.func,
  verifyPan: PropTypes.func,
  verifyCin: PropTypes.func,
  verifyGst: PropTypes.func,
  createOnboardingUser: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  vendors: makeSelectVendors(),
  twoFactorAuthentication: twoFactorAuthenticationSelector(),
});

function mapDispatchToProps(dispatch) {
  return {
    searchEasySplitVendors: data =>
      dispatch(searchEasySplitVendorsAction(data)),
    enableLoader: () => dispatch(enableLoaderAction()),
    updateTableData: data => dispatch(updateTableDataAction(data)),
    updateFilters: data => dispatch(updateFiltersAction(data)),
    resetFilters: data => dispatch(resetFiltersAction(data)),
    submitBatchUpload: data => dispatch(batchUploadSubmitAction(data)),
    resetBatchUploadResponseAction: () => dispatch(resetBatchUploadResponse()),
    createVendorData: data => dispatch(createVendorAction(data)),
    updateVendorData: data => dispatch(updateVendorAction(data)),
    createVendorNewData: data => dispatch(createVendorNewAction(data)),
    updateVendorNewData: data => dispatch(updateVendorNewAction(data)),
    resetTwoFactorAuthentication: data =>
      dispatch(resetTwoFactorAuthenticationValue(data)),
    batchDownload: data => dispatch(batchDownloadAction(data)),
    getSettlementConfig: () => dispatch(getSettlementConfigAction()),
    vendorDataById: data => dispatch(vendorDataByIdAction(data)),
    getVendorOdBalance: data => dispatch(getVendorOdBalanceAction(data)),
    initiateVendorOd: data => dispatch(initiateVendorOdAction(data)),
    resetVendorDataById: data => dispatch(resetVendorDataByIdAction(data)),
    resetPage: () => dispatch(resetPageAction()),
    resetData: () => dispatch(resetDataAction()),
    createKycData: data => dispatch(createKycAction(data)),
    downloadDoc: data => dispatch(downloadDocAction(data)),
    getKycDocs: data => dispatch(getKycDocsAction(data)),
    getBusinessInfo: data => dispatch(getBusinessInfoAction(data)),
    getDocsByUser: data => dispatch(getDocsByUserAction(data)),
    uploadVendorDocs: data => dispatch(uploadVendorDocsAction(data)),
    verifyPan: data => dispatch(verifyPanAction(data)),
    verifyGst: data => dispatch(verifyGstAction(data)),
    verifyCin: data => dispatch(verifyCinAction(data)),
    createOnboardingUser: data => dispatch(createOnboardingUsersAction(data)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
)(Vendors);

export { Vendors as PureVendors };
